// third-party
import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// project imports
import accountSliceReducer from './slices/accountSlice';
import chatbotsReducer from './slices/chatbotsSlice';
import deviceSliceReducer from './slices/deviceSlice';
import menuReducer from './slices/menu';
import snackbarReducer from './slices/snackbar';
import userProfileReducer from './slices/userProfileSlice';

// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  snackbar: snackbarReducer,
  menu: menuReducer,
  account: persistReducer(
    {
      key: 'account',
      storage,
      keyPrefix: 'guardian-'
    },
    accountSliceReducer
  ),
  device: persistReducer(
    {
      key: 'device',
      storage,
      keyPrefix: 'guardian-'
    },
    deviceSliceReducer
  ),
  userProfile: userProfileReducer,
  chatbots: chatbotsReducer
});

export default reducer;
